import React from "react";
import { DropdownProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { getGuestlistListText } from "utilities/enumutils";
import { useValidateIsNotNull } from "formvalidation/hooks";
import { formatGuestlistPaxOccupancy } from "shared/utils/guestlistUtils";

const GuestlistListsDropdown = (props: DropdownProps<server.dto.GuestlistList, number>) => {
  const validation = useValidateIsNotNull({
    key: "guestlist-access-type",
    title: RESX.Guestlist.List,
    value: props.value,
  });

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={props.options}
    getLabel={at => getGuestlistListText(at)}
    getSubLabel={at => formatGuestlistPaxOccupancy(at)}
    getValue={(t) => t.guestlistAccessTypeId}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={{
      ...props.config,
      hasError: validation.error.hasError,
    }}
  />;
};

export default GuestlistListsDropdown;
